import React, { useState } from "react";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import MangeDashboard from "./Dashboard/ManageDashboard";

export default function ForgetPassWord() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, seterror] = useState({ mobile: "", email: "" });
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [choose, setChoose] = useState("mobile");
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 768px)",
  });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });

  function handlechoose() {
    setChoose("email");
  }

  function handlechooseMobile() {
    setChoose("mobile");
  }

  function handelCheck(event) {
    event.preventDefault();
    var tagName = event.target.name;
    let p = event.target.value;

    if (tagName == "mobile") {
      // console.log("hiok");
      var pattern = new RegExp(/^09[0-9]{9}/);

      if (!pattern.test(p)) {
        seterror({
          ...error,
          mobile: "لطفا شماره تلفن خود را درست وارد نمایید",
        });
        setflag(true);
      } else if (p.length == 11) {
        seterror({ ...error, mobile: "" });
        setPhone(p);
        setflag(false);
      } else {
        seterror({
          ...error,
          mobile: "لطفا شماره تلفن خود را درست وارد نمایید",
        });
        setflag(true);
      }
    } else {
      var pattern1 = new RegExp(/^\S+@\S+\.\S+/);
      var pattern = /\S+@\S+\.\S+/;
      // console.log("hii");

      if (pattern.test(p)) {
        // console.log("hiii");
        seterror({ ...error, email: "" });
        setEmail(p);
        setflag(false);
      } else {
        setflag(true);
        seterror({ ...error, email: "لطفا ایمیل خود را درست وارد نمایید" });
      }
    }
  }

  function handelSubmit(event) {
    let formData = new FormData();
    var destination;

    if (phone) {
      formData.append("destination_address", phone);
      destination = phone;
    } else if (email) {
      formData.append("destination_address", email);
      destination = email;
    }

    axios({
      // Endpoint to send files
      url: "https://api.talaeshow.com/api/users/send-token/",
      method: "POST",
      headers: {
        // Add any auth token here
      },

      // Attaching the form data
      data: formData,
    })
      .then((res) => {
        if (res.status == 200) {
          navigate("/setpassword", { state: { destination: destination } });
        }
      })
      .catch((error) => {});
  }

  return (
    <MangeDashboard>
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-xl-8 col-md-8">
            <form className="text-center pt-5 mt-5">
              <div className="mb-4">بازیابی رمزعبور</div>

              <div className="row text-center">
                <div className="col-6 text-start">
                  <button
                    type="button"
                    id={"mobile"}
                    name="mobile"
                    className={
                      "btn-choose btn-330" +
                      (choose !== "mobile" ? " not-active-login" : "")
                    }
                    onClick={handlechooseMobile}
                  >
                    از طریق موبایل
                  </button>
                </div>

                <div className="col-6 text-end">
                  <button
                    type="button"
                    id={"email"}
                    name="email"
                    className={
                      "btn-choose btn-331" +
                      (choose !== "email" ? " not-active-login" : "")
                    }
                    onClick={handlechoose}
                  >
                    از طریق ایمیل
                  </button>
                </div>
              </div>

              <div className="authincation">
                <div className="row justify-content-center h-100 align-items-center">
                  <div className="auth-form">
                    <div>
                      <form className={"mt-4"}>
                        <div className="form-group mt-3 text-end">
                          {choose == "mobile" ? (
                            <>
                              <span className="pe-2 mynormal">موبایل</span>

                              <div className="input-group mb-3 pt-1">
                                <input
                                  type="tel"
                                  className="form-input-custom"
                                  placeholder="مثال 09120195321"
                                  id={"mobilein"}
                                  name={"mobile"}
                                  onChange={handelCheck}
                                  required
                                />
                              </div>

                              <div className={"text-danger h6 text-large"}>
                                {error.mobile}
                              </div>
                            </>
                          ) : (
                            <>
                              <span className="pe-2 mynormal">ایمیل</span>

                              <div className="input-group mb-3 pt-1">
                                <input
                                  type="email"
                                  className="form-input-custom"
                                  placeholder="مثال talaeishow@gmail.com  "
                                  id={"emailin"}
                                  name={"email"}
                                  onChange={handelCheck}
                                  required
                                />
                              </div>

                              <div className={"text-danger h6 text-large"}>
                                {error.email}
                              </div>
                            </>
                          )}
                        </div>
                        <div className="text-center pt-3 w-100 mb-2">
                          <button
                            disabled={flag}
                            type="button"
                            className="form-input-button-custom"
                            id="submit"
                            data-loading-text="<i className='fas fa-spinner fa-pulse'></i>"
                            onClick={handelSubmit}
                          >
                            {isLoading ? (
                              <div>
                                <i className="fa fa-spinner fa-spin"></i>
                              </div>
                            ) : (
                              <span>ورود</span>
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </MangeDashboard>
  );
}
